<template>
  <div class="container-fluid bg-white vh-100 p-0">
    <ClientLogo v-if="this.$route.name != 'behalf_application'" />
    <BreadCrumb label="South African Criminal Check Verification" />

    <div class="d-flex justify-content-center align-items-center min-vh-50">
      <div class="col-11 col-sm-10 col-md-8 col-lg-6 col-xl-5 p-3">
        <form @submit.prevent="submit_huru_criminal_check" class="border rounded-3 p-3">
          <div class="row g-2 my-2">
            <div class="col-md-6">
              <label class="form-label text-xs fw-semibold">First Name</label>
              <input
                v-model="form.first_name"
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter first name"
              />
            </div>
            <div class="col-md-6">
              <label class="form-label text-xs fw-semibold">Last Name</label>
              <input
                v-model="form.last_name"
                type="text"
                class="form-control form-control-sm"
                placeholder="Enter last name"
              />
            </div>
          </div>
          
          <div class="row g-2 my-2">
            <div class="col-md-12">
              <label class="form-label text-xs fw-semibold">ID Type</label>
              <select v-model="form.id_type" class="form-select form-select-sm">
                <option value="idnumber">ID Number</option>
                <option value="passport">Passport</option>
              </select>
            </div>
          </div>
          <div class="my-2">
            <label class="form-label text-xs fw-semibold">Identifier (ID Number)</label>
            <input
              v-model="form.identifier"
              type="text"
              class="form-control form-control-sm"
              placeholder="Enter ID number"
              required
            />
          </div>
          <div class="text-center mb-1 mt-4">
            <button
              type="submit"
              class="btn btn-sm bg-green secondary-text-dark rounded-small fw-bold text-xs shadow-sm"
              :disabled="submitting"
            >
              {{ submitting ? "Submitting..." : "Continue" }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb/BreadCrumb.vue";
import ClientLogo from "@/components/ClientLogo/ClientLogo.vue";
import { API_BASE_URL } from "@/config";
import { MAIN_CONTROLLER } from "@/utils/main_controller.js";
import Swal from "sweetalert2";

export default {
  name: "HuruCriminalCheckVerification",
  mixins: [MAIN_CONTROLLER],
  components: {
    BreadCrumb,
    ClientLogo,
  },
  data() {
    return {
      submitting: false,
      form: {
        identifier: "",
        id_type: "idnumber",
        first_name: "",
        last_name: "",
      },
    };
  },
  computed: {
    workflow_id() {
      return this.$store.getters.get_workflow_id;
    },
  },
  methods: {
    submit_huru_criminal_check() {
      if (!this.form.identifier) {
        Swal.fire({
          icon: "warning",
          text: "Identifier is required",
        });
        return;
      }

      const TOKEN = localStorage.getItem("token");
      const HURU_CREATE_API = `${API_BASE_URL}/verify_api/background_screening/huru_criminal_check/create-huru-criminal-check/`;

      this.submitting = true;

      $.ajax({
        url: HURU_CREATE_API,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify({
          ...this.form,
          id_verification: false,
          reason: "Criminal check request",
          workflow_id: this.workflow_id,
            on_behalf_application:
          this.$route.name === "behalf_application" ? true : false,
        }),
        success: (response) => {
          this.submitting = false;
          if (response.status === "success") {
            this.completeService();
          } else {
            Swal.fire({
              icon: "error",
              text: response.message || "Our service is currently unavailable. Please try again later",
            });
          }
        },
        error: (error) => {
          this.submitting = false;
          const errorMessage =
            error.responseJSON?.message ||
            "Our service is currently unavailable. Please try again later";
          Swal.fire({
            icon: "error",
            text: errorMessage,
          });
        },
      });
    },
  },
};
</script>
